<template> 
    <div class="exhibitor-container">
        <!-- Banner -->
        <Banner name="banner_exhibitor" />

        <div class="asset">
            <div class="asset-title">{{ assetData.title }}</div>
            <div class="asset-content">
                <div class="asset-item" v-for="item in assetData.list" :key="item.id">
                    <!-- <img :src="item.file_url" alt="" class="asset-img"> -->
                     <div class="flex name"><div class="name">{{ item.title }}</div></div>
                     <div class="down-bg">
                        <div class="down-btn" @click="downLoad(item)">{{ item.button }}</div>
                        <img class="down-img" :src="item.image_url" />
                     </div>
                     
                </div>
            </div>    
        </div>

        <div class="exhibitor">
         <div class="exhibitor-bg">
                <div class="exhibitor-container-title">{{ exhibitorData.title }}</div>
                <div class="exhibitor-container-summary">{{ exhibitorData.summary }}</div>
                <div class="exhibitor-sroll">
                    <Carousel :slides="exhibitorData.list">
                        <template #slide="{ slide }">
                            <div class="exhibitor-carousel">
                                <img :src="slide.image_url" class="exhibitor-img">
                                <div class="exhibitor-conent" v-if="slide.title || slide.summary">
                                    <div class="title">{{ slide.title }}</div>
                                    <div class="summary">{{ slide.summary }}</div>
                                </div>        
                            </div>
                        </template>
                    </Carousel>
                </div>
            </div>
        </div>

        <div class="submit">
            <div class="exhibitor-container-title">{{ lang.formTitle }}</div>
            <div class="exhibitor-container-summary">{{ lang.formSummary }}</div>
            <div class="submit-form">
                <div class="form-item-merge">
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formEnterprise }}</div>
                        <input class="form-item__input" type="text" v-model="exhibitorForm.company_name" :placeholder="lang.placeholder">
                    </div>
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formBooth }}</div>
                        <!-- <input class="form-item__input" type="text" v-model="exhibitorForm.booth_type" :placeholder="lang.placeholder"> -->
                        <div class="form-item__input form-item__type" @click="industryTypeShow = !industryTypeShow"> 
                        <div class="form-item__type-text">{{ exhibitorForm.booth_type ?? lang.pleaseSelect }}</div>
                        <img src="@assets/media/icon_select.png" srcset="@assets/media/icon_select@2x.png 2x" :class="industryTypeShow ? 'show-type' : ''" />
                    </div>
                    <div class="form-item__select" v-if="industryTypeShow">
                        <div class="form-item__select-item" v-for="(item, index) in industryType" :key="index">
                            <div class="item" 
                                @click="exhibitorForm.booth_type = item; industryTypeShow = false" 
                                :class="exhibitorForm.booth_type == item ? 'form-item__select-active' : ''">
                                    {{ item }}
                            </div>  
                        </div>
                    </div>
                    </div>
                </div>
                <div class="form-item-merge">
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formContact }}</div>
                        <input class="form-item__input" type="text" v-model="exhibitorForm.contact_name" :placeholder="lang.placeholder">
                    </div>
                    <div class="form-item">
                        <div class="form-item__title"><span class="isRed">*</span>{{ lang.formPhone }}</div>
                        <input class="form-item__input" type="text" v-model="exhibitorForm.phone" :placeholder="lang.placeholder">
                    </div>
                </div>
                
                <div class="form-item">
                    <div class="form-item__title">{{ lang.formEmail }}</div>
                    <input class="form-item__input" type="text" v-model="email" :placeholder="lang.placeholder">
                </div>

                <div class="submit-btn" @click="submitExhibitor()">{{ lang.submitBtn }}</div>
            </div>
        </div>

    </div> 
</template>

<script setup>
    import Carousel from '@/components/carousel/index.vue'
    import Banner from '@/components/banner/index.vue'
    import { onMounted, ref } from 'vue';
    import { ConfigGetAPI, AssetListAPI, ExhibitorSubmitAPI } from '@/api/common.js';
    import { useRouter } from 'vue-router'
    const router = useRouter()

    // 语言包
    const language = localStorage.getItem("language") || "zh"
    const lang = ref({})
    import(`@/language/${language}.js`).then(data => {
        lang.value = data.default.exhibitor
        industryType.value = lang.value.industry
    })  

    // 资料包
    const assetParam = ref({ name: "exhibitor_asset" })

    // 资料包数据
    const assetData = ref({})

    // 资料包获取
    const getAssetList = () => {
        ConfigGetAPI(assetParam.value).then(res => {
            assetData.value = res
        });
    }

    // 下载资料包
    const downLoad = (item) => {
        // 创建一个 <a> 标签
        const link = document.createElement('a');
        link.href = item.link_url; // 文件的URL
        link.download = item.title; // 设置下载的文件名
        document.body.appendChild(link);
        link.click(); // 触发点击事件
        document.body.removeChild(link); // 下载完成后移除 <a> 标签
    }


    // 参展商
    const exhibitorParam = ref({ name : "exhibitor_center" })

    // 参展商数据
    const exhibitorData = ref({ list:[] })

    // 参展商获取
    const getExhibitorData = () => {
        ConfigGetAPI(exhibitorParam.value).then(res => {
            exhibitorData.value = res
        });
    }

    // 参展商表单
    const exhibitorForm = ref({
        company_name: "",
        contact_name: "",
        phone: "",
        booth_type: null
    })
    // 邮箱 - 提交参展商非必填，不填不传值
    const email = ref("")

    // 所属行业筛选
    const industryType = ref(lang.value.industry)
    const industryTypeShow = ref(false)

    // 提交参展商
    const submitExhibitor = () => {
        validateField(() => {
            if(email.value) exhibitorForm.value.email = email.value
            ExhibitorSubmitAPI(exhibitorForm.value).then(() => {
                window.alert(lang.value.successSummary)
                exhibitorForm.value = {
                    company_name: "",
                    contact_name: "",
                    phone: "",
                    booth_type: ""
                }
                email.value = ""
            });
        })
    }
    // 提交参展商 字段校验
	const validateField = (callback) => {
		let msg = ''
		if (!exhibitorForm.value.company_name) msg = lang.value.tipsEnterprise
		else if (!exhibitorForm.value.contact_name) msg = lang.value.tipsContact
		else if (!exhibitorForm.value.phone) msg = lang.value.tipsPhone
		else if (!exhibitorForm.value.booth_type) msg = lang.value.tipsBooth
        else if (email.value) {
            const emailReg = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            if (!emailReg.test(email.value)) msg = lang.value.tipsEmail
        }
		msg ? window.alert(msg) : callback?.()
	}

    onMounted(() => {
        getAssetList()
        getExhibitorData();
    });

</script>

<style lang="scss" scoped>

.exhibitor-container {
    .flex {
        display: flex;
    }
    &-title {
        font-family: PingFangSC-medium;
        color: #333333;
        font-weight: 500;
        font-size: 36px;
        letter-spacing: 3px;
        line-height: 56px;  
        margin-bottom: 16px;  
    }

    &-summary {
        color: #666666;
        font-weight: 400;
        font-size: 24px;
        letter-spacing: 2px;
        line-height: 40px;

    }

    .banner {
        width: 100%;
        overflow: hidden;

        .banner-img {
            width: 100%;
            object-fit: cover;
        }
    }
    
    .asset {
        width: 1200px;
        margin: 100px auto 80px auto;
        border-radius: 30px;
        background-color: #FFFFFF;
        box-shadow: 0px 10px 18px 0px rgba(40, 44, 108, 0.09);
        padding: 24px;

        &-title {
            font-family: PingFangSC-medium;
            color: #333333;
            font-weight: 500;
            font-size: 28px;
            letter-spacing: 2px;
            line-height: 40px;
            margin-bottom: 24px;
        }

        &-content {
            display: flex;
            flex-wrap: wrap;
            gap: 25px;
        }

        &-item {
            width: 273px;
            height: 168px;
            border-radius: 10px;
            background: linear-gradient(134.26deg, rgba(248, 254, 250, 1) 0%, rgba(255, 255, 255, 0.64) 100%);
            border: 1px solid rgba(230, 230, 230, 0.6);
            display: flex;
            flex-direction: column;
            justify-content: center;
            padding: 24px;
            box-sizing: border-box;
            position: relative;

            .name {
                color: #666666;
                font-weight: 400;
                font-size: 18px;
                letter-spacing: 1px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                max-width: 100%;
            }

            .down-bg {
                display: flex;
                justify-content: space-between;
                align-items: center;
            }

            .down-btn {
                padding: 0 15px;
                height: 32px;
                border-radius: 33px;
                background-color: #F8FAFC;
                line-height: 32px;
                text-align: center;
                color: #333333;
                font-weight: 400;
                font-size: 14px;
                letter-spacing: 1px;
                margin-top: 35px;
                cursor: pointer;
            }

            .down-btn:hover{
                opacity: .75;
            }

            .down-img {
                width: 96px;
                height: 96px;
                position: absolute;
                right: 0px;
                bottom: 0px;
                z-index: 0;
            }

        }

    }

    .exhibitor {
        background-color: #F8FAFC;
        padding: 50px 0;
        
        &-bg {
            width: 1200px;
            margin: 0 auto;
        }

        &-sroll{
            margin: 36px 0;
        }

        &-carousel {
            position: relative;
            width: 1200px;
            height: 675px;
        }

        &-conent {
            position: absolute;
            bottom: 0px;
            width: 1200px;
            height: 197px;
            background-color: rgba(6, 6, 6, 0.5);
            border-radius: 0 0 30px 30px;
            box-sizing: border-box;
            padding: 28px 50px;
            color: #FFFFFF;

            .title {
                font-family: PingFangSC-medium;
                font-weight: 500;
                font-size: 24px;
                letter-spacing: 2px;
                line-height: 33px;
            }

            .summary {
                font-weight: 400;
                font-size: 20px;
                letter-spacing: 2px;
                line-height: 40px;
            }
        }

        &-img {
            width: 1200px;
            height: 675px;
            border-radius: 30px;
            object-fit: cover;
        }
    }

    .submit {
        width: 1200px;
        margin: 100px auto 80px auto;

        &-form {
            border-radius: 8px;
            background-color: #FFFFFF;
            border: 1px solid #F0F0F0;
            box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
            margin-top: 24px;
            padding: 24px;
            display: flex;
            flex-direction: column;
            align-items: center;

            .form-item-merge {
                display: flex;
                justify-content: space-between;
                width: 670px;

                .form-item {
                    width: 324px !important;
                }
            }

            .form-item {
                margin-bottom: 14px;
                width: 670px;
                
                &__title {
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    margin-bottom: 10px;

                    .isRed {
                        color: #FF5219;
                        padding-right: 4px;
                    }
                }

                &__input {
                    background-color: #F7F7FA;
                    border: none;
                    padding: 14px 12px;
                    line-height: 18px;
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    width: 100%;
                    box-sizing: border-box;
                    border-radius: 4px;
                }

                &__type {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    cursor: pointer;

                    &-text {
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }

                    img {
                        transition: transform 0.25s ease;
                    }

                    img:hover {
                        opacity: .75;
                    }

                    .show-type {
                        transform: rotate(-180deg);
                    }
                }

                &__select {
                    width: 324px;
                    border-radius: 10px;
                    background-color: #FFFFFF;
                    box-shadow: 0px 10px 18px 0px rgba(40, 44, 108, 0.09);
                    margin-top: 14px;
                    padding: 12px;
                    color: #333333;
                    font-weight: 400;
                    font-size: 16px;
                    box-sizing: border-box;
                    position: absolute;
                    transition: opacity 0.5s ease, max-height 0.5s ease;
                    overflow: hidden;
                    
                    &-item {
                        line-height: 22px;
                        padding: 12px;
                        cursor: pointer;
                    }

                    &-active {
                        font-family: PingFangSC-medium;
                        color: #1753A3;
                        font-weight: 500;
                    }

                    &-item:hover {
                        color: #1753A3;
                    }

                }
            
            }

            .submit-btn {
                width: 670px;
                height: 74px;
                border-radius: 37px;
                background: linear-gradient(90deg, rgba(19, 94, 205, 1) 0%, rgba(12, 72, 161, 1) 100%),#F8FAFC;
                line-height: 74px;
                text-align: center;
                margin-top: 10px;
                font-family: PingFangSC-medium;
                color: #FFFFFF;
                font-weight: 500;
                font-size: 24px;
                letter-spacing: 2px;
                cursor: pointer;
            }
        }
    }
}

/* 响应式布局 */
@media (max-width: 768px) {
    .exhibitor-container {
        &-title {
            font-size: 18px;
            letter-spacing: 0;
            line-height: 24px;  
            margin-bottom: 12px;  
        }

        &-summary {
            font-size: 14px;
            letter-spacing: 1px;
            line-height: 20px;

        }

        .asset {
            width: calc(100% - 24px);
            margin: 24px 12px;
            border-radius: 10px;
            background-color: #FFFFFF;
            padding: 12px;
            box-sizing: border-box;

            &-title {
                font-weight: 600;
                font-size: 18px;
                letter-spacing: 0;
                line-height: 24px;
                margin-bottom: 8px;
            }

            &-content {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
            }

            &-item {
                width: 48%;
                height: 98px;
                border-radius: 5px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                padding: 12px;
                box-sizing: border-box;

                .name {
                    font-size: 12px;
                    letter-spacing: 0;
                }

                .down-bg {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: 10px;

                    img {
                        width: 58px;
                        height: 58px;
                    }
                }

                .down-btn {
                    width: fit-content;
                    height: 20px;
                    border-radius: 33px;
                    line-height: 20px;
                    font-weight: 400;
                    font-size: 10px;
                    letter-spacing: 0;
                    margin-top: 0px;
                }

                .down-img {
                    right: 0px;
                    bottom: 0px;
                    z-index: 0;
                }

            }

        }

        .exhibitor {
            background-color: #F8FAFC;
            padding: 24px 12px;
            
            &-bg {
                width: 100%;
                margin: 0 auto;
            }

            &-sroll{
                margin: 12px 0;
            }

            &-carousel {
                position: relative;
                width: 100%;
                height: 200px;
            }

            &-conent {
                bottom: 0px;
                width: 100%;
                height: 80px;
                border-radius: 0 0 10px 10px;
                box-sizing: border-box;
                padding: 12px;

                .title {
                    font-family: PingFangSC-medium;
                    font-weight: 500;
                    font-size: 16px;
                    letter-spacing: 1px;
                    line-height: 22px;
                }

                .summary {
                    font-weight: 400;
                    font-size: 12px;
                    letter-spacing: 1px;
                    line-height: 16px;
                    margin-top: 5px;
                }
            }

            &-img {
                width: 100%;
                height: 200px;
                border-radius: 10px;
            }
        }

        .submit {
            width: 100%;
            margin: 0;
            padding: 24px 12px;
            box-sizing: border-box;

            &-form {
                border-radius: 8px;
                background-color: #FFFFFF;
                border: 1px solid #F0F0F0;
                box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.05);
                margin-top: 12px;
                padding: 12px;
                display: flex;
                flex-direction: column;
                align-items: center;

                .form-item-merge {
                    display: block;
                    width: 100%;

                    .form-item {
                        width: 100% !important;
                    }
                }

                .form-item {
                    margin-bottom: 10px;
                    width: 100%;
                    
                    &__title {
                        color: #333333;
                        font-weight: 400;
                        font-size: 14px;
                        margin-bottom: 6px;

                        .isRed {
                            color: #FF5219;
                            padding-right: 4px;
                        }
                    }

                    &__input {
                        padding: 10px 8px;
                        line-height: 16px;
                        color: #333333;
                        font-size: 12px;
                        width: 100%;
                        box-sizing: border-box;
                        border-radius: 4px;
                    }

                    &__select {
                        width: calc(100% - 50px);
                        border-radius: 4px;
                        margin-top: 7px;
                        font-size: 12px;
                        
                        &-item {
                            line-height: 16px;
                            padding: 8px;
                        }

                    }
                
                }

                .submit-btn {
                    width: 100%;
                    height: 40px;
                    border-radius: 37px;
                    line-height: 40px;
                    text-align: center;
                    margin-top: 10px;
                    font-size: 14px;
                    letter-spacing: 1px;
                }
            }
        }
    }
}

</style>
    

